module.exports = __webpack_public_path__ + "img/bdd86f8.png";